import { PendingPayAdjustment } from "../PendingPayAdjustment";
import { DataHeader, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutPayAdjustmentHistory extends Layout {
    dataheaderPayAdjustment: DataHeader;
    layoutPayAdjustment: PendingPayAdjustment;
    sourceDrsDeductHist: DataSource;
    sourceJournalDriver: DataSource;
}
